module.exports = __webpack_public_path__ + "static/img/lab.d8217f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lab.png
// module id = l6xs
// module chunks = 1